import { MediaLibrary, Pictures } from "../types";
import { AllActions } from "../actions";
import { keys } from "../utils/utils";
import { Reducer } from "redux";

const initialState: MediaLibrary = {
  pictures: {},
  logoId: undefined,
  groups: [],
  picturesByGroupId: {},
};

const getAllMediaSuccess = (
  state: MediaLibrary,
  pictures: Pictures
): MediaLibrary => {
  const pictureKeys = keys(pictures);
  const logoId = pictureKeys.find((key) => pictures[key].category === "logo");
  return { ...state, pictures, logoId };
};

const getMediaGroupSuccess = ({
  state,
  groupId,
  pictures,
}: {
  state: MediaLibrary;
  groupId: number;
  pictures: Pictures;
}): MediaLibrary => {
  const pictureKeys = keys(pictures);

  return {
    ...state,
    picturesByGroupId: {
      ...state.picturesByGroupId,
      [groupId]: pictureKeys,
    },
  };
};

const reducer: Reducer<MediaLibrary, AllActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "GET_ALL_MEDIA_SUCCESS":
      return getAllMediaSuccess(state, action.pictures);

    case "GET_ALL_MEDIA_GROUPS_SUCCESS":
      return { ...state, groups: action.groups };

    case "GET_MEDIA_GROUP_SUCCESS":
      return getMediaGroupSuccess({
        state,
        groupId: action.groupId,
        pictures: action.pictures,
      });

    default:
      return state;
  }
};

export default reducer;
